import { render } from "./AwardsSection.vue?vue&type=template&id=685b241a&scoped=true"
const script = {}

import "./AwardsSection.vue?vue&type=style&index=0&id=685b241a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685b241a"]])

export default __exports__